'use strict';

angular.module('TurneroApp').component('coErrores', {
    bindings: {
    },
    controller: [
          '$mdDialog',
		  'utilsService',
          'errorsService',
		  'TurneroAppConstant',
		  '$stateParams',
		  '$window',
		  function ($mdDialog, utilsService, errorsService, TurneroAppConstant, $stateParams, $window) {
		      var ctrl = this;
		      ctrl.$onChanges = function () {
		          ctrl.cargarGrilla();
		      }

		      ctrl.errores = [];
		      ctrl.pagination = {
		          total: null
		      };


		      ctrl.limitOptions = [10, 25, 50, 75, 100, {
		          label: 'Todos',
		          value: function () {
		              return ctrl.pagination.total;
		          }
		      }];

		      ctrl.resetFilter = function () {
		          ctrl.query = {
		              i_tipo_error: "",
		              i_nro_pagina: 1,
		              i_tam_pagina: 20
		          }
		      }
		      ctrl.resetFilter();

		      ctrl.grillaReload = function () {
		          ctrl.resetFilter();
		          ctrl.cargarGrilla();
		      }

		      ctrl.cargarGrilla = function () {
		          errorsService.Log_Error_Get({
		              'filtro.Tipo_Error': ctrl.query.i_tipo_error,
		              'filtro.Nro_Pagina': ctrl.query.i_nro_pagina,
		              'filtro.Tam_Pagina': ctrl.query.i_tam_pagina
		          }).$promise.then(function (resultado) {
		              ctrl.pagination.total = resultado.Pagination.Reg_Totales;
		              ctrl.errores = resultado.Data;
		          }).catch(function (resultado) {
		              console.log(resultado)
		          })
		      }


		      ctrl.mostrarBuscar = function () {
		          ctrl.filter = true;
		          ctrl.focusBuscar = true;
		      };

		      ctrl.removeFilter = function () {
		          ctrl.query.filter = '';
		          ctrl.cargarGrilla();
		          ctrl.filter = false;
		      };


		      ctrl.viewDetails = function (item) {
		          $mdDialog.show({
		              template:
                        '<md-dialog aria-label="List dialog">' +
                        '  <md-dialog-content>' +
                        '    <code>' + item.Backtrace + '</code>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button ng-click="closeDialog()" class="md-primary">' +
                        '      Cerrar' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
		              controller: function DialogController($scope, $mdDialog) {
		                  $scope.closeDialog = function () {
		                      $mdDialog.hide();
		                  }
		              }
		          });

		      }


		  }],
    template: require('./errors.html')
});



// WEBPACK FOOTER //
// ./app/components/layout/errores/errorsComponent.js